<main class="access-denied"
  [style.--xa-denied-primary]="theme.primaryColor"
  [style.--xa-denied-bg]="theme.backgroundColor"
  [style.--xa-denied-text]="theme.textSecondaryColor">
  <section class="access-denied-card" role="alert" aria-labelledby="access-denied-title">
    <div class="access-denied-visual" aria-hidden="true">
      <span class="access-denied-halo"></span>
      <img class="access-denied-avatar" [src]="avatarUrl" alt="">
      <span class="access-denied-badge">
        <svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3.5" y="9" width="13" height="9" rx="2"></rect>
          <path d="M6.5 9V6.25a3.5 3.5 0 0 1 7 0V9"></path>
          <path d="M10 12.5v2"></path>
        </svg>
      </span>
    </div>

    <h1 id="access-denied-title" class="access-denied-title">{{ 'ai_agent_external_access_denied_title' | translate }}</h1>
    <p class="access-denied-message">{{ 'ai_agent_external_access_denied_message' | translate }}</p>
  </section>
</main>
